import React, { useState } from "react";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import DeletePopUp from "../Popups/DeletePopUp";
import { RiDeleteBinLine } from "react-icons/ri";
import { FiPlusCircle } from "react-icons/fi";
import { AiFillCloseCircle } from "react-icons/ai";
import Crossword, { ThemeProvider } from "@jaredreisinger/react-crossword";
import "../CSS/AddQuestion.css";

const CrossWordPreview = () => {
  const [state, setState] = useState(false);
  const [count, setCount] = useState(0);
  const [remove, setRemove] = useState(false);

  const deleteword = () => {
    setRemove(!remove);
  };
  const data = {
    /* ... puzzle data (see below) ... */

    across: {
      1: {
        clue: "one plus one",
        answer: "ABSOLUTE",
        row: 0,
        col: 1,
      },
      3: {
        clue: "one plus one",
        answer: "JUICE",
        row: 2,
        col: 4,
      },
      5: {
        clue: "one plus one",
        answer: "SPICEJAR",
        row: 6,
        col: 2,
      },
    },
    down: {
      2: {
        clue: "one plus one",
        answer: "EVER",
        row: 0,
        col: 8,
      },
      4: {
        clue: "one plus one",
        answer: "OBJECTION",
        row: 0,
        col: 4,
      },
    },
  };
  return (
    <>
      <div className="CreatePuzzle_wrapper">
        <nav className="navbar navbar-expand-lg navbar-addquestion">
          <div className="container-fluid">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarText"
              aria-controls="navbarText"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarText">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item " id="add-question-edit">
                  <p
                    className="nav-link active text-decoration-underline list active"
                    aria-current="page"
                    id="question"
                  >
                    Question
                  </p>
                </li>
                <li className="nav-item" id="themes">
                  <p className="nav-link list " aria-current="page" id="themes">
                    Themes
                  </p>
                </li>
                <li className="nav-item" id="duration-add-question">
                  <p className="nav-link " aria-current="page" href="#">
                    Duration:
                    <input type="time" value="10:05 AM" />
                  </p>
                </li>
                <li className="nav-item" id="preview-add-question">
                  <p className="nav-link " aria-current="page" href="#">
                    Preview
                  </p>
                </li>
                <li className="nav-item" id="preview-close-add-question">
                  <Link to="/homeview">
                    {" "}
                    <p className="nav-link " aria-current="page" href="#">
                      <i>
                        <AiFillCloseCircle />
                      </i>
                    </p>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <div>
          <div className="row">
            <div className="col-md-12 d-flex">
              <div className="col-md-8">
                <div className="add-question-left">
                  <div className="create-question-board">
                    <div className=" d-flex">
                      <div className="col-md-6">
                        <label for="inputName" className="form-label">
                          Select Unit
                        </label>
                        <Form.Select
                          aria-label="Default select example"
                          placeholder="Ex: Unit1"
                        >
                          <option>Level 1</option>
                          <option>Level 2</option>
                          <option>Level 3</option>
                          <option>Level 4</option>
                        </Form.Select>
                      </div>
                      <div className="col-md-6">
                        <label for="inputName" className="form-label">
                          Activity no
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="inputName"
                          placeholder="Peterson"
                        />
                      </div>
                    </div>
                    <div>
                      <label for="inputName" className="form-label">
                        Title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputName"
                        placeholder="Eg: Write down the name of creature who lives in ocean"
                      />
                    </div>
                    <div>
                      <Table bordered className="puzzle-table-crud mt-4">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Words</th>
                            <th>Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td id="puzzle-sno">1</td>
                            <td>
                              {" "}
                              {state ? (
                                <span>Fish</span>
                              ) : (
                                <span onClick={() => setState(true)}>
                                  click
                                </span>
                              )}
                            </td>
                            <td>
                              <button onClick={deleteword}>
                                <RiDeleteBinLine />
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td id="puzzle-sno">2</td>
                            <td>
                              {" "}
                              {state ? (
                                <span>Cat</span>
                              ) : (
                                <span onClick={() => setState(true)}></span>
                              )}
                            </td>
                            <td>
                              <button>
                                <RiDeleteBinLine />
                              </button>
                              {/* <button>
                                <FiPlusCircle />
                              </button> */}
                            </td>
                          </tr>
                          <tr>
                            <td id="puzzle-sno">3</td>
                            <td></td>
                            <td>
                              {" "}
                              <button>
                                <RiDeleteBinLine />
                              </button>
                              {/* <button>
                                <FiPlusCircle />
                              </button> */}
                            </td>
                          </tr>
                          <tr>
                            <td id="puzzle-sno">4</td>
                            <td></td>
                            <td>
                              {" "}
                              <button>
                                <RiDeleteBinLine />
                              </button>
                              {/* <button>
                                <FiPlusCircle />
                              </button> */}
                            </td>
                          </tr>
                          {count ? (
                            <tr>
                              <td id="puzzle-sno">{count + 4}</td>
                              <td></td>
                              <td>
                                {" "}
                                <button>
                                  <RiDeleteBinLine />
                                </button>
                                {/* <button>
                                  <FiPlusCircle />
                                </button> */}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}
                        </tbody>
                      </Table>
                      {remove ? <DeletePopUp handleClose={deleteword} /> : ""}
                    </div>
                    <div className="puzzle-footer d-flex">
                      <div
                        className="col-md-6 d-flex"
                        onClick={() => setCount(count + 1)}
                      >
                        <button>
                          <FiPlusCircle />
                        </button>
                        <p>Add Question</p>
                      </div>
                      <div className="col-md-6">
                        <button className="puzzle-Save-button">Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="create-preview-board">
                  <div
                    style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      width: "20em",
                    }}
                  >
                    <ThemeProvider
                      theme={{
                        allowNonSquare: false,
                        columnBreakpoint: "9999px",
                        gridBackground: "#08134A",
                        cellBackground: "#fff",
                        cellBorder: " #08134A",
                        textColor: "#225A6F",
                        numberColor: "rgba(0,0,0, 0.25)",
                        numberColor: "#9f9",
                        highlightBackground: "#fff",
                        focusBackground: "#fff",
                      }}
                    >
                      <Crossword data={data} />
                    </ThemeProvider>
                    {/* <img src={Number} alt="" className="Number_Img1" /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CrossWordPreview;
